import { useCallback, useContext, useState } from "react";
import NotyfContext from "../contexts/NotyfContext";
import { getStatusMessage } from "../utils/helpers";

export default function useFetchItemById({
    id,
    fetcher = null,
    moduleName: defaultModuleName = '',

    onErrorCallback = null,
    onErrorAsyncCallback = null,

    onSuccessCallback = null,
    onSuccessAsyncCallback = null,

    initialLoadingState = false,
    suppressFetchError = false,
} = {}){
    const notyf = useContext(NotyfContext)

    const [data, setData] = useState(null)
    const [dataId, setDataId] = useState(null)
    const [isLoading, setIsLoading] = useState(initialLoadingState)

    const clearData = useCallback(()=>{
        setData(null)
        setDataId(null)
    }, [setData, setDataId])

    const fetchData = useCallback(async({ id: customId, moduleName, payload } = {}) => {
        try{
            const module = moduleName ?? defaultModuleName

            const itemId = id ?? customId

            if(module === 'create' || !itemId) return setIsLoading(false)

            setIsLoading(true)

            clearData()

            const result = await fetcher?.(itemId, payload)

            if(result){
                setDataId(itemId)
                setData(result?.data?.data ?? result?.data ?? result)
                onSuccessCallback?.()
                await onSuccessAsyncCallback?.()
            }

            return result
        }catch(error){
            onErrorCallback?.()
            onErrorAsyncCallback?.()
            !suppressFetchError && notyf.open({ type: "danger", message: getStatusMessage(error)});

            throw error
        }finally{
            setIsLoading(false)
        }
    }, [
        id,
        setData,
        fetcher,
        setIsLoading,
        defaultModuleName,

        onErrorCallback,
        onErrorAsyncCallback,

        onSuccessCallback,
        onSuccessAsyncCallback
    ])

    return {
        data, setData,

        dataId, setDataId,

        isLoading, setIsLoading,
        
        fetchData, clearData
    }
}